import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import {
  AlertController,
  CheckboxCustomEvent,
  LoadingController,
  ModalController,
  NavController,
  ToastController,
} from '@ionic/angular';
import { CartPage } from '../cart/cart.page';
import { GlobalVariable } from '../global';
import { OrderSettingsPage } from '../order-settings/order-settings.page';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.page.html',
  styleUrls: ['./item-details.page.scss'],
})
export class ItemDetailsPage implements OnInit {
  @Input('reward_flag') reward_flag;
  @Input('reward_id') reward_id;
  @Input('image') image;
  @Input('item_id') item_id;

  @Input('BusinesId') BusinesId;
  @Input('type') type;
  @Input('itemData') itemData;
  @Input('business') business;
  @Input('Index') Index;

  flag: boolean = true;
  noExtras: boolean;
  buttonDisabled: boolean;
  No_of_Free_Extras: any;

  index: number;
  isexist: boolean = false;
  date: Date;
  time: any;
  day: any;
  instructions: any = '';
  instr: any = '';
  totalCost: any = 0;
  extratotal: any = 0;
  objectPrice: any = 0;

  myList: any;
  id: any;

  checkstatus: boolean;
  extras: any;

  description: any;
  bannerimage: any;
  data: any;

  tagline: any;
  price: number = 0;
  name: any;
  Image: any;
  quantity: number = 1;
  myChoices: any = [];
  array_index: any = [];
  checked: boolean;
  options: any[];
  op: any[];
  temp: any[] = new Array();
  checkedItems: boolean[];
  extraChecked: boolean = false;
  item_price: number = 0;
  reward_item_flag: boolean = false;
  // reward_id: any;
  // type: boolean = true;
  stock_quantity: any;
  itemShowFlag: boolean = false;
  optionitemArray: any;
  upSellItem_array = [];
  price_temp: any;
  extraitemPrice: number = 0;
  requiredExtras: any = [];
  requiredtemp: boolean;
  attributeId: any;
  // itemData: any;
  currentIndex: number = 0;
  pickupTime: string;
  longitude: number;
  latitude: number;
  businessData: any;
  resAddress: any;
  value: any;
  dateNow: string;
  Business_id: any;
  ItemId: any;
  thumbimage: any;
  promoItem: boolean=false;
  item: any;
  promoAvailedQuantity: any=0;
  constructor(
    private photoViewer: PhotoViewer,
    public server: ServerService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public router: Router,
    private toastCtrl: ToastController
  ) {}

  ngOnInit() {}
  ionViewWillEnter() {
    this.globals.udid=localStorage.getItem('udid')
    if (!this.reward_item_flag) {
      this.reward_item_flag = false;
    }
    if (this.reward_item_flag) {
      // if (!this.globals.OrderType) {
      //   this.presentModal1();
      // }
    }
    // this.reward_id = navParams.get('reward_id')
    // this.thumbimage = navParams.get('image');

    // this.ItemId = navParams.get('item_id');
    // this.Business_id = navParams.get('BusinesId');
    // this.type = navParams.get('type');
    // this.itemData=navParams.get('itemData')
    // let b_data=navParams.get('business');//getting from menu page
    this.businessData = this.business;
    if (this.BusinesId) {
      this.Business_id = this.BusinesId;
    }
    if (this.item_id) {
      this.ItemId = this.item_id;
    }
    if (this.image) {
      this.thumbimage = this.image;
    }
    // console.log('active business',this.businessData);
    // console.log('asdasd',this.item_id)
    // if()
    // console.log('xxx',this.ItemId)
    // console.log('selected item from cart ',this.itemData)
    if (this.itemData != undefined) {
      console.log('coming from cart');
      //business data
      if (this.business != undefined) {
        console.log('business is not undefined  ......  ');
        this.businessData = this.business;
        this.globals.activeCartBusinessData = this.businessData;
        this.globals.setupBusiness(this.globals.activeBusinessData); //31st march
      } else {
        this.businessData = this.globals.activeCartBusinessData;
        console.log('business is  undefined  ......  ');

        this.globals.setupBusiness(this.globals.activeCartBusinessData); //31st march
      }
      if (this.Index) {
        this.currentIndex = this.Index;
      }
      // this.currentIndex=navParams.get('Index')
      this.quantity = this.itemData.quantity;
      this.globals.itemDetail = this.itemData;
      this.item_price = this.itemData.totalPrice;
      this.globals.itemDetail.name = this.itemData.menuItem;

      this.instructions = this.itemData.itemInstructions;
      this.extras = this.itemData.menuExtrasSelected;
      console.log('from cart selected extras', this.extras);

      // newww
      // if(this.itemData!=undefined){
      // this.myChoices= this.itemData.menuExtrasSelected;
      // console.log('My choices',this.myChoices)
      //  }
      // new ends
    }
    this.timingSetting();
    this.itemDetails();
  }
  timingSetting() {
    console.log('checking');
    this.pickupTime = this.globals.myDate;
    let temdate = localStorage.getItem('scheduled_time');
    if (temdate != null || temdate != '' || temdate != undefined) {
      this.pickupTime = temdate;
    }
    if (this.pickupTime != null) {
      if (this.pickupTime.length > 0) {
        this.pickupTime = this.pickupTime.replace('T', ' ');
        this.pickupTime = this.pickupTime.slice(0, 16);
      }
    }
    // setup business for usage in app - part of new halal guide app
    // this.businessData = this.navParams.get("businessData");
    // this.resAddress=this.businessData.address;

    // this.globals.bussinessId = this.businessData.business_id;
    // console.log('business id is', this.globals.bussinessId)
    //if returning from external link
    // if (this.globals.activeBusinessData != undefined) {
    //   this.businessData = this.globals.activeBusinessData
    //   // this.globals.bussinessId = this.businessData.business_id;
    // }
    //ends here
    // this.globals.activeBusinessData = this.businessData;
    console.log(this.businessData);
    this.name = this.businessData.name;
    let long = parseFloat(this.businessData.longitude);
    let lat = parseFloat(this.businessData.latitude);
    this.longitude = long;
    this.latitude = lat;
    console.log('entered in item detail page');

    console.log(this.businessData);
    // if (this.businessData) {
    //   this.globals.setupBusiness(this.businessData);
    // }

    if (!this.globals.caos_flag) {
      // || this.businessData.delivery=="1"
      if (this.businessData.pickup == '1') {
        console.log('pick and delivery check  ');
        // this.globals.OrderType="pickup";
        this.min_date_value();
        // this.globals.myDate= Date.now()
        // this.presentModal(0);
      }
    } else {
      // this.globals.OrderType = "pickup";
      console.log('Order type is -> ', this.globals.OrderType);
    }
  }
  // presentModal1() {
  //   let modal = this.modalCtrl.create('ModalPage');
  //   modal.present();
  // }
  ionViewWillLeave() {
    if (this.itemData == undefined) {
      // this.globals.dataNotLoaded = true;
    }
  }
  min_date_value() {
    var date = new Date();

    var datenow = date.getDate().toString();
    // var datenow  =moment().format('YYYY-MM-DD HH:mm');

    var month = (date.getMonth() + 1).toString();
    var year = date.getFullYear().toString();

    if (month.length < 2) month = '0' + month;
    if (datenow.length < 2) datenow = '0' + datenow;
    this.value = year + '-' + month + '-' + datenow;
    this.value.toString();

    console.log('value', this.value);

    // var date1 = moment().format('YYYY-MM-DD HH:mm');
    var date1 = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    this.dateNow = date1;
    if (!this.globals.myDate) {
      this.globals.myDate = date1;
      localStorage.setItem('scheduled_time', this.globals.myDate);
      // this.myPDate=moment().format('MMMM Do YYYY, h:mm:ss a');
      // this.myPDate=this.globals.myDate
      // console.log('date is,',this.myPDate)
    }
  }
  close() {
    this.modalCtrl.dismiss();
  }
  openOptionDetail(list, event, i) {
    console.log(list, i);
    if (this.optionitemArray) {
      if (list.heading == this.optionitemArray.heading) {
        this.itemShowFlag = false;
        this.optionitemArray = null;
      } else {
        this.itemShowFlag = true;
        this.optionitemArray = list;
      }
    } else {
      this.itemShowFlag = true;
      this.optionitemArray = list;
    }
  }

  // presentModal() {
  //   let modal = this.modalCtrl.create('InstructionModalPage', { instructions: this.instructions });
  //   modal.present();
  //   modal.onDidDismiss((data) => {
  //     this.instructions = data;
  //     console.log("instructions from modal", this.instructions);
  //   });
  // }

  image_show(image) {
    this.photoViewer.show(image, '', { share: true });
  }

  async cartpage() {
    if (this.globals.Product.length == 0) {
      let alert = await this.alertCtrl.create({
        header: 'Oops',
        message: 'Your cart is empty.',
        buttons: ['Okay'],
      });
      alert.present();
    } else {
      this.navCtrl.navigateForward('cart');
      // this.router.navigate(['/cart']).then(res=>{
      //   console.log(res)
      // })
      // let modal=await this.modalCtrl.create({
      //   component:CartPage,
      //   cssClass:'cartModal'
      // })
      // modal.present();
    }
  }

  addQuantity() {
  
    //if promoitem...
    if(this.promoItem==true){
      let max
      console.log('is promo item.......')
      // if (this.itemData != undefined) {
      //   console.log(this.itemData);
      //   max=Number(this.itemData.max_allowed);
      // }
      // else{
        max=Number(this.item.max_allowed)
        max=max-this.promoAvailedQuantity
        if(this.promoAvailedQuantity==this.item.max_allowed){
          this.globals.presentToast("You've reached the limit of this item")
          return
        }
      // }
      if(this.quantity<max ){
        this.quantity += 1;
        // this.item_price =
        // this.extraitemPrice * this.quantity + this.price * this.quantity;
        this.item_price = this.extraitemPrice * this.quantity + Number(this.price) * this.quantity;
      let tempPrice = this.item_price.toFixed(2);
      this.item_price = Number(tempPrice);
      console.log(this.item_price,this.price,this.extraitemPrice)


      }

}
else{
//if promotitem


    if (this.quantity < this.stock_quantity) {
      this.quantity += 1;
      // var m_price = 0;
      // this.myChoices.forEach(element => {
      //   element.options.forEach(subelement => {
      //     m_price = m_price + subelement.price;
      //   });
      // });
      // this.item_price = (Number(this.item_price) + (Number(this.myChoices[c].options[b].price) * this.quantity)).toFixed(2);

      this.item_price =
        this.extraitemPrice * this.quantity + Number(this.price) * this.quantity;
      let tempPrice = this.item_price.toFixed(2);
      this.item_price = Number(tempPrice);
      console.log(this.item_price,this.price,this.extraitemPrice)

    } else {
      this.globals.presentToast('You have selected max. limit of item.');
    }
  }
  }

  removeQuantity() {
 
    if (this.quantity <= 1) {
      this.quantity = 1;
      // this.promoAvailedQuantity=this.quantity
    } else {
      this.quantity -= 1;
      if(this.promoAvailedQuantity!=0){
        this.promoAvailedQuantity=this.quantity

      }

    }

    // this.myChoices.forEach(element => {
    //   element.options.forEach(subelement => {
    //     m_price = m_price + subelement.price;
    //   });
    // });

    this.item_price =
      this.extraitemPrice * this.quantity + this.price * this.quantity;
    let tempPrice = this.item_price.toFixed(2);
    this.item_price = Number(tempPrice);
  }

  extrasTotal(){
    console.log('extras counting ')
    this.extraitemPrice=0
this.myChoices.forEach(items=>{
  items.options.forEach(item=>{
    console.log(item)
    this.extraitemPrice+=Number(item.total)
  })
})
  }
  addOptionQuantity(heading, object) {
    console.log('object', object);
    object.quantity += 1;
    var value1 = this.myChoices.indexOf([object]);
    this.myChoices.splice(value1, 1);

    var data = {
      heading: heading,
      options: [
        {
          name: object.name,
          price: Number(object.price),
          quantity: object.quantity,
          total: Number(object.price) * object.quantity,
          isFree: false,
        },
      ],
    };
    this.myChoices.push(data);
  }

  removeOptionQuantity(heading, object) {
    console.log('object', object);
    if (object.quantity <= 1) {
      object.quantity = 1;
    } else {
      object.quantity -= 1;
      var value1 = this.myChoices.indexOf([object]);
      this.myChoices.splice(value1, 1);
      var data = {
        heading: heading,
        options: [
          {
            name: object.name,
            price: Number(object.price),
            quantity: object.quantity,
            total: Number(object.price) * object.quantity,
            isFree: false,
          },
        ],
      };
      this.myChoices.push(data);
    }
  }

  Cart() {
    if (
      this.globals.BusinessID == '-1' ||
      this.globals.BusinessID == this.Business_id
    ) {
      this.globals.BusinessID = this.Business_id;
      this.AddtoCart();
      // this.itemInstructions();
    } else {
      this.showPrompt();
    }
  }

  showPrompt() {
    this.globals.Product.length = 0;
    this.globals.BusinessID = this.Business_id;
    this.AddtoCart();
  }

  async AddtoCart() {
    this.globals.activeCartBusinessData = this.businessData;
    let cartAdditionLoader = await this.loadingCtrl.create({
      message: 'Adding...',
    });

    let areAllCategoryCountsFound: boolean = false;
    let totalCategoriesCount: number = 0;
    let categoryCount: number = 0;
    if (this.extras) {
      for (let i = 0; i < this.extras.length; i++) {
        if (this.extras[i].min != '' && Number(this.extras[i].min) > 0) {
          totalCategoriesCount++;
          if (!this.requiredtemp) {
            this.requiredExtras.push(this.extras[i].heading);
          }
        }
      }
      for (let e = 0; e < this.extras.length; e++) {
        // newww
        if (this.itemData != undefined) {
          this.myChoices = this.itemData.menuExtrasSelected;
        }
        // new ends
        for (let c = 0; c < this.myChoices.length; c++) {
          if (this.extras[e].heading == this.myChoices[c].heading) {
            console.log('if');
            if (
              this.extras[e].min != '' &&
              Number(this.extras[e].min) > 0 &&
              this.myChoices[c].options.length >= Number(this.extras[e].min)
            ) {
              console.log('inner if');
              categoryCount++;
              break;
            }
          }
        }
      }
    }

    if (categoryCount == totalCategoriesCount) {
      areAllCategoryCountsFound = true;
    }

    if (areAllCategoryCountsFound) {
      let isMenuItemSame: boolean = false;
      this.globals.Product.forEach((menuItem) => {
        if (menuItem.uniqueId == this.ItemId) {
          if (this.instructions == '' && menuItem.instructions == '') {
            let menuExtraCategoryLength: any =
              menuItem.menuExtrasSelected.length;
            if (menuExtraCategoryLength == this.myChoices.length) {
              let isMenuItemExtraCategoriesCount: any = 0;
              for (let i = 0; i < menuExtraCategoryLength; i++) {
                for (let j = 0; j < this.myChoices.length; j++) {
                  if (
                    menuItem.menuExtrasSelected[i].heading ==
                    this.myChoices[j].heading
                  ) {
                    let currentExtraCategoryOptionsLength: any =
                      menuItem.menuExtrasSelected[i].options.length;
                    if (
                      currentExtraCategoryOptionsLength ==
                      this.myChoices[j].options.length
                    ) {
                      let isMenuItemExtraCategoriesItemCount: any = 0;
                      for (
                        let k = 0;
                        k < currentExtraCategoryOptionsLength;
                        k++
                      ) {
                        for (
                          let m = 0;
                          m < this.myChoices[j].options.length;
                          m++
                        ) {
                          if (
                            menuItem.menuExtrasSelected[i].options[k].name ==
                              this.myChoices[j].options[m].name &&
                            menuItem.menuExtrasSelected[i].options[k]
                              .quantity == this.myChoices[j].options[m].quantity
                          ) {
                            isMenuItemExtraCategoriesItemCount++;
                            break;
                          }
                        }
                      }
                      if (
                        isMenuItemExtraCategoriesItemCount ==
                        currentExtraCategoryOptionsLength
                      ) {
                        isMenuItemExtraCategoriesCount++;
                        break;
                      }
                    }
                  }
                }
              }
              if (isMenuItemExtraCategoriesCount == menuExtraCategoryLength) {
                isMenuItemSame = true;
              }
            }
          }
        }
      });
      if (isMenuItemSame) {
        for (let i = 0; i < this.globals.Product.length; i++) {
          if (this.name == this.globals.Product[i].menuItem) {
            let currentQuantity = this.globals.Product[i].quantity;
            currentQuantity += this.quantity;
            let current_total = this.quantity * this.price;
            this.globals.Product[i].quantity = currentQuantity;
            this.globals.Product[i].totalPrice += current_total;
            break;
          }
        }
        this.modalCtrl.dismiss();
      } else {
        this.totalCost = this.quantity * this.price;
        let i = 1;

        for (let sub of this.myChoices) {
          for (let op of sub.options) {
            if (Number(this.No_of_Free_Extras) >= 1) {
              if (op.quantity > 1) {
                let prod_quantity = op.quantity;

                for (let j = prod_quantity; j > 0; j--) {
                  if (this.No_of_Free_Extras >= 1) {
                    prod_quantity = prod_quantity - 1;
                    this.No_of_Free_Extras--;
                    this.extratotal = 0;
                  } else {
                    this.extratotal = this.extratotal + op.price;
                  }
                }

                if (prod_quantity == 0) {
                  op.isFree = true;
                }
                op.quantity = prod_quantity;
              } else {
                this.extratotal = 0;
                op.isFree = true;
                this.No_of_Free_Extras--;
              }
            } else {
              this.extratotal += op.quantity * op.price;
            }
            i = i++;
          }
        }
        this.objectPrice = Number(this.item_price);

        this.objectPrice.toFixed(2);
        this.globals.itemInstruction = this.instructions;
        if (this.reward_item_flag == true) {
          var reward_duplicate = false;
          this.globals.Product.forEach((menuItem) => {
            if (menuItem.reward_id == this.reward_id) {
              reward_duplicate = true;
            }
          });
          if (!reward_duplicate) {
            this.globals.Product.push({
              menuId: '1',
              restId: this.globals.bussinessId,
              uniqueId: this.ItemId,
              menuItem: this.name,
              image: this.thumbimage,
              promotional:this.promoItem,
              quantity: this.quantity,
              itemInstructions: this.instructions,
              price: this.price,
              totalPrice: this.objectPrice,
              menuExtrasSelected: this.myChoices,
              menuUpsellItemsSelected: [],
              upsell_calculated: false,
              reward: this.reward_item_flag,
              reward_id: this.reward_id,
              tax: this.data.item.tax,
              tax_enabled: this.data.item.tax_enabled,
              discount_value: this.data.item.discount_value,
              discount_type: this.data.item.discount_type,
              attributeId: this.attributeId,
            });
            this.globals.presentToast('Reward added in your cart');
            this.modalCtrl.dismiss();
          } else {
            this.globals.presentToast(
              'You have already add this reward in cart.'
            );
            this.modalCtrl.dismiss();
          }
        } else {
          if (this.itemData != undefined) {
            console.log('upadting itm in cart>>>>>');
            this.globals.dataNotLoaded = false;

            // this.globals.Product.push({ menuId: "1", restId: this.globals.bussinessId, uniqueId: this.ItemId, menuItem: this.name, image: this.thumbimage, quantity: this.quantity, itemInstructions: this.instructions, basePrice: this.price, totalPrice: this.objectPrice, menuExtrasSelected: this.myChoices, menuUpsellItemsSelected: [], upsell_calculated: false, reward: this.reward_item_flag, reward_id: this.reward_id, tax: this.data.item.tax, tax_enabled: this.data.item.tax_enabled, discount_value: this.data.item.discount_value, discount_type: this.data.item.discount_type, attributeId:this.attributeId });
            this.globals.Product.splice(this.currentIndex, 1, {
              menuId: '1',
              restId: this.globals.bussinessId,
              uniqueId: this.ItemId,
              menuItem: this.name,
              image: this.thumbimage,
              promotional:this.promoItem,
              quantity: this.quantity,
              itemInstructions: this.instructions,
              price: this.price,
              basePrice: this.price,
              totalPrice: this.objectPrice,
              menuExtrasSelected: this.myChoices,
              menuUpsellItemsSelected: [],
              upsell_calculated: false,
              reward: this.reward_item_flag,
              reward_id: this.reward_id,
              tax: this.data.item.tax,
              tax_enabled: this.data.item.tax_enabled,
              discount_value: this.data.item.discount_value,
              discount_type: this.data.item.discount_type,
              attributeId: this.attributeId,
            });
          } else {
            console.log('first time added');
            this.globals.Product.push({
              menuId: '1',
              restId: this.globals.bussinessId,
              uniqueId: this.ItemId,
              menuItem: this.name,
              image: this.thumbimage,
              quantity: this.quantity,
              promotional:this.promoItem,
              itemInstructions: this.instructions,
              price: this.price,
              totalPrice: this.objectPrice,
              menuExtrasSelected: this.myChoices,
              menuUpsellItemsSelected: [],
              upsell_calculated: false,
              reward: this.reward_item_flag,
              reward_id: this.reward_id,
              tax: this.data.item.tax,
              tax_enabled: this.data.item.tax_enabled,
              discount_value: this.data.item.discount_value,
              discount_type: this.data.item.discount_type,
              attributeId: this.attributeId,
              basePrice: this.price,
            });
          }
        }

        this.modalCtrl.dismiss();
        localStorage.removeItem('instructions');
        // if (this.upSellItem_array.length > 0) {
        //   let modal = this.modalCtrl.create('UpSellItemModalPage', { place: this.globals.business_username, itemId: this.ItemId, upSellItems: this.upSellItem_array });
        //   modal.present();
        // } else {

        // }
      }
    } else {
      this.requiredtemp = true;
      this.globals.presentToast(
        'Please select the required extras.' + this.requiredExtras
      );
    }
  }

  itemDetails() {
   

    let response = this.server.ProductItemDetail(this.ItemId);
    response.subscribe(
      (data) => {
        this.globals.dataNotLoaded = false;
        this.data = data;

        this.id = this.data.item.id;
        // changed.......
        // this.globals.itemDetail=this.data.item
        // ....
        console.log('api response', this.data.item);

        // loading.dismiss();
          this.item=this.data.item;
          if(this.item.promotional==true){
             this.promoItem=true//if item is promotional

             this.globals.Product.forEach(item=>{
              if(this.item.id==item.uniqueId){
                console.log(item.uniqueId)
                this.promoAvailedQuantity= this.promoAvailedQuantity+item.quantity
                
                // this.globals.presentToast("You've already added promotional itemin cart")
                // return;
              }
                if(this.itemData!=undefined){
                  this.promoAvailedQuantity=0;
                }
            })

          }
          //vvvvvvvvvv
          // this.itemData=this.item
        this.bannerimage = this.data.item.image;
        this.description = this.data.item.description;
        this.name = this.data.item.name;
        this.globals.title = this.name;
        this.Image = this.data.item.image;
        this.price = this.data.item.price;
        if (this.itemData != undefined) {
          this.item_price = this.itemData.totalPrice;
        } else {
          this.item_price = this.price;
        }

        this.stock_quantity = this.data.item.stock_quantity;
        this.upSellItem_array = this.data.item.upsellItems;
        this.attributeId = this.data.item.attribute_id;

        if (this.reward_item_flag == true) {
          this.item_price = 0;
        }

        this.No_of_Free_Extras = Number(this.data.item.freeExtras);
        if (this.data.item.extras.length > 0) {
          var noExtras = false;
          // new
          if (this.itemData != undefined) {
            this.extras = this.itemData.menuExtrasSelected;
            console.log('coming from cart');
          } else {
            this.extras = this.data.item.extras;
            console.log(this.extras);

            this.extras.forEach(options=>{
              options.options.forEach(item=>{
                item.IsSelected=false;
              })
            })
          }
          // new end
          if (this.reward_item_flag == true) {
            this.extras.forEach((extra_price) => {
              if (Number(extra_price.min) > 0) {
                extra_price.options.forEach((ex) => {
                  ex.price = 0;
                });
              }
            });
          }
        

          this.extras.forEach((extra_items) => {
            extra_items.options.forEach((item) => {
              if (item.in_stock) {
                item.disable_item = false;
              } else {
                item.disable_item = false;
              }
            });
          });

          this.extras.forEach((element) => {
            if (element.heading == '') {
              element.options.forEach((element1) => {
                if (element1.name == '') {
                  noExtras = true;
                } else {
                  noExtras = false;
                }
              });
            }
          });
          console.log('habibi.......',this.extras)
          this.noExtras = noExtras;
        }
      },
      (error) => {
        console.log('Error!');
      }
    );
  }
  async presentModal(type) {
    console.log('model called from category page');
    if (type == 1) {
      let modal = await this.modalCtrl.create({
        component: OrderSettingsPage,
      });
      modal.onDidDismiss().then((data) => {
        if (data != null || data != undefined) {
          this.globals.myDate = data.data.date;
          this.pickupTime = this.globals.myDate;
          this.pickupTime = this.pickupTime.replace('T', ' ');
          this.pickupTime = this.pickupTime.slice(0, 16);
        }
        console.log('data returned from model.=> ', data);
      });
      modal.present();
    } else {
      if (this.globals.model_flag) {
        this.globals.model_flag = false;
        let modal = await this.modalCtrl.create({
          component: OrderSettingsPage,
        });
        modal.onDidDismiss().then((data) => {
          console.log('data returned from model.=> ', data);
          if (data != null || data != undefined) {
            this.pickupTime = this.globals.myDate = data.data.date;
            this.pickupTime = this.globals.myDate;
            this.pickupTime = this.pickupTime.replace('T', ' ');
            this.pickupTime = this.pickupTime.slice(0, 16);
          }
          var orderSchedule = localStorage.getItem('scheduled_time');
          if (
            orderSchedule == undefined ||
            orderSchedule == 'undefined' ||
            (this.globals.OrderType == 'delivery' &&
              (this.globals.inradius == false || this.globals.address == ''))
          ) {
            this.globals.model_flag = true;
            this.navCtrl.navigateRoot('home');
          }
        });
        modal.present();
      }
    }
  }
  // toggle(){
  //   console.log('toggle')
  //   this.extras.forEach(options=>{
  //     options.options.forEach(item=>{
  //       item.IsSelected=true;
  //     })
  //   })

  // }
  total_price() {
    this.extraitemPrice = 0;
    console.log('item price counting,item  ', this.globals.itemDetail);
    this.item_price = this.globals.itemDetail.price * this.quantity;
    console.log('total amount', this.item_price);
    for (let c = 0; c < this.myChoices.length; c++) {
      for (
        let b = this.myChoices[c].freeExtras;
        b < this.myChoices[c].options.length;
        b++
      ) {
        if (this.itemData != undefined) {
          this.extraitemPrice =
            this.extraitemPrice + Number(this.myChoices[c].options[b].price)
          this.item_price =
            this.item_price +
            this.myChoices[c].options[b].price * this.quantity;
        } else {
          console.log('here')
          this.extraitemPrice =
            this.extraitemPrice + Number(this.myChoices[c].options[b].price)
            console.log(this.extraitemPrice)
          this.item_price =
            this.item_price +
            this.myChoices[c].options[b].price * this.quantity;
        }
        // this.extraitemPrice
        // this.extraitemPrice = this.extraitemPrice+this.myChoices[c].options[b].price;
        // this.item_price = (Number(this.item_price) + (Number(this.myChoices[c].options[b].price) * this.quantity)).toFixed(2);
        console.log('total amount with extras', this.item_price,this.extraitemPrice);
      }
    }
  }
  async selectedOption(heading, option, freeExtras, max, event,categoryIndex,itemIndex) {
    var checked = false;
    let flag: boolean = false;
    if(this.extras[categoryIndex].options[itemIndex].IsSelected==true){
      this.extras[categoryIndex].options[itemIndex].IsSelected==false; 
    option.IsSelected = false;

    }
    else{
    option.IsSelected = true;
    // this.extras[categoryIndex].options[itemIndex].IsSelected==true; 


      
    }
    // debugger;
    console.log(heading, option,freeExtras, max);
    // option.IsSelected = event.detail.checked;
    // checked=event.detail.checked
    option.price = Number(option.price).toFixed(2);

    console.log('Checking price', option.price);
 

    if (
      !freeExtras ||
      freeExtras == 'null' ||
      freeExtras == 'undefined' ||
      freeExtras == ''
    ) {
      freeExtras = 0;
    }
    if (this.itemData != undefined) {
      // this.myChoices=this.itemData.menuExtrasSelected;
      // option.IsSelected=true
      // if(option.IsSelected==true){
      //   option.IsSelected=false;
      // }
    }
    debugger;
    if (option.IsSelected) {
      console.log('is checked', option.IsSelected);
      let same: boolean = false;

      for (let m = 0; m < this.myChoices.length; m++) {
        if (this.myChoices[m].heading == heading) {
          same = true;
          // console.log('max extras are   ', max);
          if (max == '') {
            max = 1000;
          }

          if (this.myChoices[m].options.length >= Number(max)) {
            // event.preventDefault();
                 option.IsSelected = false;
            // event.detail.checked = false;

            console.log('here...max ',this.myChoices[m].options.length >= Number(max))
            this.flag = true;
            console.log(categoryIndex,itemIndex);
            this.extras[categoryIndex].options[itemIndex].IsSelected=false;
            // this.extras[categoryIndex].options[itemIndex].IsSelected=false;
            // this.extras=this.extras;
            // console.log(this.myChoices[m]);
            // this.extras[categoryIndex].options.forEach((itemEx,iEx) => {
              // for(let a=0; a<this.myChoices.length; a++){


              // }
              this.myChoices.forEach(itemss=>{
                if(itemss.heading== this.extras[categoryIndex]){
                  itemss.options.forEach((itemMy,iMy)=>{ //active items
                    console.log('my choice names.. ',itemMy)
                    this.extras[categoryIndex].options.forEach((itemA,iA)=>{  //all items of extras
                      if( itemA.name!==itemMy.name){
                          console.log('not active names', itemA.name);
                          this.extras[categoryIndex].options[iA].IsSelected=false;
                      }
                      else{
                        console.log('active name ',itemMy.name)
                        this.extras[categoryIndex].options[iA].IsSelected=true;
    
                      } 
      
                      })
    
                  })

                }

              })
              // this.myChoices[m].options.forEach((itemMy,iMy)=>{ //active items
              //   console.log('my choice names.. ',itemMy)
              //   this.extras[categoryIndex].options.forEach((itemA,iA)=>{  //all items of extras
              //     if( itemA.name!==itemMy.name){
              //         console.log('not active names', itemA.name);
              //         this.extras[categoryIndex].options[iA].IsSelected=false;
              //     }
              //     else{
              //       console.log('active name ',itemMy.name)
              //       this.extras[categoryIndex].options[iA].IsSelected=true;

              //     } 
  
              //     })

              // })

              
            // });
            console.log('total extras ',this.extras[categoryIndex])
             

           
            // option.IsSelected = false;
            // event.detail.checked = false;

            let toast = await this.toastCtrl.create({
              message: 'Oops !! You have added max number of extras',
              duration: 2000,
              position: 'bottom',
              color:'dark'
            });
            this.flag = false;
            // event.preventDefault();

            await toast.present();
            // debugger
            console.log('end....')
            // return;
            // break;
          } else {
            this.myChoices[m].options.push({
              name: option.name,
              price: option.price,
              quantity: 1,
              total: Number(option.price) * option.quantity,
              isFree: false,
              IsSelected: option.IsSelected,
            });
            this.total_price();
            // this.item_price = (Number(this.item_price) + (Number(op.price) * this.quantity)).toFixed(2);
            console.log('myprice', this.item_price);
            this.flag = false;
            // return;
            // break;
          }
        }
      }
      if (!same) {
        console.log('same check',same);
        if (this.No_of_Free_Extras == 0) {
          var data = {
            heading: heading,
            freeExtras: freeExtras,
            max: max,
            options: [
              {
                name: option.name,
                price: option.price,
                quantity: option.quantity,
                total: Number(option.price) * option.quantity,
                isFree: false,
                IsSelected: option.IsSelected,
              },
            ],
          };

          // this.item_price = (Number(this.item_price) + (Number(op.price) * this.quantity)).toFixed(2);

          this.myChoices.push(data);
          this.total_price();
          this.flag = false;
        } else {
          if (this.myChoices.length < this.No_of_Free_Extras) {
            var data = {
              heading: heading,
              freeExtras: freeExtras,
              max: max,
              options: [
                {
                  name: option.name,
                  price: null,
                  quantity: option.quantity,
                  total: 0,
                  isFree: true,
                  IsSelected: option.IsSelected,
                },
              ],
            };
            this.myChoices.push(data);
            this.flag = false;
          } else {
            var data = {
              heading: heading,
              freeExtras: freeExtras,
              max: max,
              options: [
                {
                  name: option.name,
                  price: option.price,
                  quantity: option.quantity,
                  total: Number(option.price) * option.quantity,
                  isFree: false,
                  IsSelected: option.IsSelected,
                },
              ],
            };

            this.myChoices.push(data);
            this.total_price();
            this.flag = false;
          }
        }
      }
    } else {
      console.log('checked ......',option.IsSelected);
      this.total_price();
      if (this.flag == false) {
        console.log('flag false');
        var value = this.myChoices.findIndex((item, i) => {
          return item.heading === heading;
        });

        if (this.myChoices[value].options.length > 1) {
          console.log('length is greater than 1', this.myChoices);
          this.myChoices[value].options.map((checkitem, i, array) => {
            console.log(checkitem, i, array);

            if (checkitem.name == option.name) {
              // this.extras[value].options[i].IsSelected=false; //new
              console.log('after removing a item my list', this.myChoices);
              array.splice(i, 1);
              this.total_price();
              // this.item_price = (Number(this.item_price) - (Number(op.price) * this.quantity)).toFixed(2);
            }
          });
        } else {
          if (this.myChoices.length > 0) {
            for (let i = 0; i < this.myChoices.length; i++) {
              if (this.myChoices[i].options[0].name == option.name) {
                if (this.myChoices[i].options[0].isFree) {
                } else {
                  this.total_price();
                }
              }
            }
          } else {
          }
          this.myChoices.map((checkitem, i, array) => {
            console.log(checkitem, i, array);

            if (checkitem.heading == heading) {
              array.splice(i, 1);
              this.total_price();
            }
          });
        }
      }

      if (this.flag == true) {
      } else {
      }
    }
  }

  // async selectedOption(heading, option, freeExtras, a, i, max, event) {
  //   // console.log(event)
  //   // op.IsSelected=event.checked;
  //   Number(option.price).toFixed(2);

  //   console.log('Checking price', option.price);
  //   var checked = false;
  //   let flag: boolean = false;

  //   if (
  //     !freeExtras ||
  //     freeExtras == 'null' ||
  //     freeExtras == 'undefined' ||
  //     freeExtras == ''
  //   ) {
  //     freeExtras = 0;
  //   }
  //   if (this.itemData != undefined) {
  //     // this.myChoices=this.itemData.menuExtrasSelected;
  //     // option.IsSelected=true
  //     // if(option.IsSelected==true){
  //     //   option.IsSelected=false;
  //     // }
  //   }
  //   if (option.IsSelected) {
  //     console.log('is checked', option.IsSelected);
  //     let same: boolean = false;

  //     for (let m = 0; m < this.myChoices.length; m++) {
  //       if (this.myChoices[m].heading == heading) {
  //         same = true;
  //         console.log(max);
  //         if (max == '') {
  //           max = 1000;
  //         }

  //         if (this.myChoices[m].options.length >= Number(max)) {
  //           console.log('here')
  //           this.flag = true;
  //           option.IsSelected = false;
  //           event.checked = false;

  //           let toast = await this.toastCtrl.create({
  //             message: 'Oops !! You have added max number of extras',
  //             duration: 2000,
  //             position: 'bottom',
  //             color: 'primary',
  //           });
  //           this.flag = false;

  //           toast.present();
  //         } else {
  //           this.myChoices[m].options.push({
  //             name: option.name,
  //             price: option.price,
  //             quantity: 1,
  //             total: Number(option.price) * option.quantity,
  //             isFree: false,
  //             IsSelected: option.IsSelected,
  //           });
  //           this.total_price();
  //           // this.item_price = (Number(this.item_price) + (Number(op.price) * this.quantity)).toFixed(2);
  //           console.log('myprice', this.item_price);
  //           this.flag = false;
  //           break;
  //         }
  //       }
  //     }
  //     if (!same) {
  //       if (this.No_of_Free_Extras == 0) {
  //         var data = {
  //           heading: heading,
  //           freeExtras: freeExtras,
  //           max: max,
  //           options: [
  //             {
  //               name: option.name,
  //               price: option.price,
  //               quantity: option.quantity,
  //               total: Number(option.price) * option.quantity,
  //               isFree: false,
  //               IsSelected: option.IsSelected,
  //             },
  //           ],
  //         };

  //         // this.item_price = (Number(this.item_price) + (Number(op.price) * this.quantity)).toFixed(2);

  //         this.myChoices.push(data);
  //         this.total_price();
  //         this.flag = false;
  //       } else {
  //         if (this.myChoices.length < this.No_of_Free_Extras) {
  //           var data = {
  //             heading: heading,
  //             freeExtras: freeExtras,
  //             max: max,
  //             options: [
  //               {
  //                 name: option.name,
  //                 price: null,
  //                 quantity: option.quantity,
  //                 total: 0,
  //                 isFree: true,
  //                 IsSelected: option.IsSelected,
  //               },
  //             ],
  //           };
  //           this.myChoices.push(data);
  //           this.flag = false;
  //         } else {
  //           var data = {
  //             heading: heading,
  //             freeExtras: freeExtras,
  //             max: max,
  //             options: [
  //               {
  //                 name: option.name,
  //                 price: option.price,
  //                 quantity: option.quantity,
  //                 total: Number(option.price) * option.quantity,
  //                 isFree: false,
  //                 IsSelected: option.IsSelected,
  //               },
  //             ],
  //           };

  //           // this.item_price = (Number(this.item_price) + (Number(op.price) * this.quantity)).toFixed(2);

  //           this.myChoices.push(data);
  //           this.total_price();
  //           this.flag = false;
  //         }
  //       }
  //     }
  //   } else {
  //     console.log('is selceted false......');
  //     this.total_price();
  //     if (this.flag == false) {
  //       console.log('flag false');
  //       var value = this.myChoices.findIndex(function (item, i) {
  //         return item.heading === heading;
  //       });

  //       if (this.myChoices[value].options.length > 1) {
  //         console.log('length is greater than 1', this.myChoices);
  //         this.myChoices[value].options.map((checkitem, i, array) => {
  //           console.log(checkitem, i, array);

  //           if (checkitem.name == option.name) {
  //             console.log('after removing a item my list', this.myChoices);
  //             array.splice(i, 1);
  //             this.total_price();
  //             // this.item_price = (Number(this.item_price) - (Number(op.price) * this.quantity)).toFixed(2);
  //           }
  //         });
  //       } else {
  //         if (this.myChoices.length > 0) {
  //           for (let i = 0; i < this.myChoices.length; i++) {
  //             if (this.myChoices[i].options[0].name == option.name) {
  //               if (this.myChoices[i].options[0].isFree) {
  //               } else {
  //                 this.total_price();
  //                 // this.item_price = (Number(this.item_price) - (Number(op.price) * this.quantity)).toFixed(2);
  //               }
  //             }
  //           }
  //         } else {
  //         }
  //         this.myChoices.map((checkitem, i, array) => {
  //           console.log(checkitem, i, array);

  //           if (checkitem.heading == heading) {
  //             array.splice(i, 1);
  //             this.total_price();
  //           }
  //         });
  //       }
  //     }

  //     if (this.flag == true) {
  //     } else {
  //     }
  //   }
  // }

  checkTiming(timing) {
    if (this.globals.order_time == 'schedule') {
      if (this.globals.specific_delivery_day == 'true') {
        return true;
      }

      var day = this.globals.schedule_day_id + 1;
      if (day == 7) {
        day = 0;
      }

      var time = this.globals.schedule_converted_time;
      var current_day = timing[day];
      var n = current_day[0].indexOf('.');

      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }

      var n1 = current_day[1].indexOf('.');

      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      if (
        (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
        (Number(current_day[0]) <= time &&
          Number(current_day[1]) < Number(current_day[0]))
      ) {
        return true;
      } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
        return true;
      } else {
        this.toast();
        // this.globals.presentToast('Sorry, we are not serving ' + this.globals.OrderType + ' at time you schedule!')
        return false;
      }
    } else {
      var date = new Date();
      var day: any = date.getDay();
      var time: any = date.getHours() + '.' + date.getMinutes();
      time = Number(time);

      var current_day = timing[day];
      var n = current_day[0].indexOf('.');

      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }

      var n1 = current_day[1].indexOf('.');

      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      if (
        (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
        (Number(current_day[0]) <= time &&
          Number(current_day[1]) < Number(current_day[0]))
      ) {
        return true;
      } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
        return true;
      } else {
        this.toast();
        // this.globals.presentToast('Sorry, we are not serving ' + this.globals.OrderType + ' at this time!')
        return false;
      }
    }
  }

  // itemInstructions(){
  //   this.globals.menu_item_arr.push({"ID": this.globals.menu_id, "INST": this.instructions});
  //    console.log('modal IDs',this.globals.menu_item_arr);
  // }
  async toast() {
    let toast = await this.toastCtrl.create({
      icon: 'timer',
      color: 'dark',
      mode: 'ios',
      position: 'top',
      message:
        'Sorry, we are not serving ' +
        this.globals.OrderType +
        ' at this time!',
      duration: 4000,
    });
    toast.present();
  }
  checkPromotional(){
    this.globals.presentToast('Please wait...',2000,'middle','dark');
    let item_id;
    if (this.itemData != undefined) {
      item_id=this.itemData.uniqueId
    }
    else{
      item_id=this.id
    }
    this.server.checkPromotional(item_id,this.quantity).subscribe(async res=>{
      console.log('promo res  ',res);
      if(res.success==true){
        if(this.promoAvailedQuantity==this.item.max_allowed){
          this.globals.presentToast("You've reached the limit of this item")
          return
        }

        // this.Cart();

//new added 30-jun
        if (this.globals.Product.length == 0) {
          console.log('first time adding');
          this.globals.businessInCartId = this.Business_id;
          console.log('id is ', this.globals.businessInCartId);
          if (this.globals.OrderType == 'delivery') {
            if (this.checkTiming(this.globals.delivery_timing)) {
              this.Cart();
            }
          } else {
            if (this.checkTiming(this.globals.pickup_timing)) {
              this.Cart();
            }
          }
        } else if (this.globals.Product.length > 0) {
          console.log('cart has items from', this.globals.businessInCartId);
          if (this.globals.businessInCartId == this.Business_id) {
            console.log('id matched');
            if (this.globals.OrderType == 'delivery') {
              if (this.checkTiming(this.globals.delivery_timing)) {
                this.Cart();
              }
            } else {
              if (this.checkTiming(this.globals.pickup_timing)) {
                this.Cart();
              }
            }
          } else {
            console.log('Id not matched');
            const alert = await this.alertCtrl.create({
              message:
                'You have already selected products from a different restaurant. if you continue,your cart and selection will be removed.',
              buttons: [
                {
                  text: 'Cancel',
                  cssClass: 'cancel_btn',
                  handler: (data) => {
                    console.log('Cancel clicked');
                  },
                },
                {
                  text: 'Clear and Continue',
                  handler: (data) => {
                    this.globals.Product = [];
                    this.globals.businessInCartId = this.Business_id;
                    if (this.globals.OrderType == 'delivery') {
                      if (this.checkTiming(this.globals.delivery_timing)) {
                        this.Cart();
                      }
                    } else {
                      if (this.checkTiming(this.globals.pickup_timing)) {
                        this.Cart();
                      }
                    }
                  },
                },
              ],
            });
            await alert.present();
            // return false;
          }
        }


//new added 30-jun


      }
      else{
        this.globals.presentToast(res.message,3000,'middle','primary');
      }
    },err=>{
      console.log(err)
    })
  }
  async add_to_cart_timing_check() {
    let promotional;
    // if (this.itemData != undefined) {
    //   promotional=this.itemData.promotional;
    // }
    // else{
      promotional=this.item.promotional
      // promotional=true //for testing
    // }
    if(promotional==true){ 
      this.promoItem=true//if item is promotional
      this.checkPromotional();

    }
    else{ //if item is not promotional
    if (this.globals.Product.length == 0) {
      console.log('first time adding');
      this.globals.businessInCartId = this.Business_id;
      console.log('id is ', this.globals.businessInCartId);
      if (this.globals.OrderType == 'delivery') {
        if (this.checkTiming(this.globals.delivery_timing)) {
          this.Cart();
        }
      } else {
        if (this.checkTiming(this.globals.pickup_timing)) {
          this.Cart();
        }
      }
    } else if (this.globals.Product.length > 0) {
      console.log('cart has items from', this.globals.businessInCartId);
      if (this.globals.businessInCartId == this.Business_id) {
        console.log('id matched');
        if (this.globals.OrderType == 'delivery') {
          if (this.checkTiming(this.globals.delivery_timing)) {
            this.Cart();
          }
        } else {
          if (this.checkTiming(this.globals.pickup_timing)) {
            this.Cart();
          }
        }
      } else {
        console.log('Id not matched');
        const alert = await this.alertCtrl.create({
          message:
            'You have already selected products from a different restaurant. if you continue,your cart and selection will be removed.',
          buttons: [
            {
              text: 'Cancel',
              cssClass: 'cancel_btn',
              handler: (data) => {
                console.log('Cancel clicked');
              },
            },
            {
              text: 'Clear and Continue',
              handler: (data) => {
                this.globals.Product = [];
                this.globals.businessInCartId = this.Business_id;
                if (this.globals.OrderType == 'delivery') {
                  if (this.checkTiming(this.globals.delivery_timing)) {
                    this.Cart();
                  }
                } else {
                  if (this.checkTiming(this.globals.pickup_timing)) {
                    this.Cart();
                  }
                }
              },
            },
          ],
        });
        await alert.present();
        // return false;
      }
    }
  }
  //end of else.......
  }
}
